import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
} from "@/libs/@ey-xd/motif-react";

import {
  useLazyDeleteStageQuery,
  useLazyDeleteStatusQuery,
} from "@/services/stages/stagesReducer";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";

import "./Stages.css";
import { useTrans } from "@/components/Functions/dateFunc";
interface ApiResponse {
  data?: any;
  error?: any;
}

export default function DeleteStageStatus({
  show,
  setShow,
  id,
  getStageData,
  isStage,
  selectedStage,
  setSelectedStage,
  setDeleteErrorMessage,
  deleteEntityName,
  setShowToast,
  setShowDeleteSuccessMessage,
  showDeleteSuccessMessage,
}: {
  show: boolean;
  setShow: (show: boolean) => void;
  id: any;
  getStageData: (isCreate: boolean) => void;
  isStage: boolean;
  selectedStage: string;
  setSelectedStage: (stageId: string) => void;
  setDeleteErrorMessage: any;
  deleteEntityName: any;
  setShowToast?: any;
  setShowDeleteSuccessMessage?: any;
  showDeleteSuccessMessage?: any;
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [deleteStageQuery] = useLazyDeleteStageQuery();
  const [deleteStatusQuery] = useLazyDeleteStatusQuery();
  const { caseId } = useParams();
  const claimStatusDefinitionId = id;

  const handleDelete = () => {
    const deleteQuery = isStage ? deleteStageQuery : deleteStatusQuery;
    setDeleteErrorMessage({ type: "", message: "", show: false });
    setIsLoading(true);
    deleteQuery({ claimStatusDefinitionId, caseId }).then(
      (response: ApiResponse) => {
        if (response.data) {
          if (isStage && selectedStage === id) {
            setSelectedStage("");
            getStageData(false);
          } else {
            getStageData(true);
          }
          if (
            showDeleteSuccessMessage.index >= 0 ||
            showDeleteSuccessMessage.index === undefined
          ) {
            setShowDeleteSuccessMessage &&
              setShowDeleteSuccessMessage({
                ...showDeleteSuccessMessage,
                type: "success",
                message: `${
                  isStage ? "Stage" : "Status"
                } got deleted successfully`,
                show: true,
                variant: isStage ? "stage" : "status",
              });
          } else {
            setShowToast &&
              setShowToast({
                type: "success",
                message: `${
                  isStage ? "Stage" : "Status"
                } got deleted successfully`,
                show: true,
                variant: isStage ? "stage" : "status",
              });
          }
        } else {
          setShowToast({
            type: "",
            message: "",
            show: true,
            variant: "",
          });
          let target = document.getElementById(id);
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
          const errorMessage = response.error.data.message;
          setDeleteErrorMessage({
            type: "error",
            message: errorMessage,
            show: true,
          });
        }
        setIsLoading(false);
        setShow(false);
      }
    );
  };

  const handleCancel = () => {
    setShow(false);
    setDeleteErrorMessage({ type: "", message: "", show: false });
    setShowToast({
      type: "",
      message: "",
      show: true,
      variant: "",
    });
  };

  return (
    <>
      <MotifModal
        onClose={handleCancel}
        show={show}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>
          <MotifModalBody style={{ paddingTop: "0px" }}>
            {useTrans(
              t,
              t(
                isStage
                  ? "pages.configuration.stages.deleteStageMessage"
                  : "pages.configuration.stages.deleteStatusMessage",
                { name: deleteEntityName }
              ),
              "stageandstatus"
            )}
          </MotifModalBody>

          <MotifModalFooter>
            <MotifButton
              onClick={handleCancel}
              type="button"
              variant="secondary"
            >
              {t("pages.configuration.stages.cancel")}
            </MotifButton>
            <MotifButton
              onClick={handleDelete}
              type={isLoading ? "loader" : "submit"}
              variant="primary"
            >
              {t("pages.configuration.stages.confirm")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
